import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // adapte selon ton env
  withCredentials: true,            // ✅ Envoie toujours les cookies
  timeout: 5000 //5 secondes
});

export default axiosInstance;